import React, { useState, useEffect } from "react";
import {
  FaShoppingCart,
  FaUser,
  FaHome,
  FaBox,
  FaSignOutAlt,
} from "react-icons/fa";
import { GrSearch } from "react-icons/gr";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import logo from "../assest/products/extra/logo.jpeg";
import { logoutUser } from "../store/userSlice";
import { motion } from "framer-motion";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cartCount = useSelector((state) => state.cart.cartCount);
  const user = useSelector((state) => state.user.user);

  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [search, setSearch] = useState("");

  const texts = ["Search laptops...", "Gaming laptops...", "Refurbished laptops..."];
  const [placeholder, setPlaceholder] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let i = 0;

    const interval = setInterval(() => {
      setPlaceholder(texts[index].slice(0, i));
      i++;

      if (i > texts[index].length) {
        clearInterval(interval);
        setTimeout(() => {
          setIndex((prev) => (prev + 1) % texts.length);
        }, 1500);
      }
    }, 60);

    return () => clearInterval(interval);
  }, [index]);

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/search?q=${search}`);
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    setDropdown(false);
    setMenuOpen(false);
    navigate("/login");
  };

  return (
    <>
      {/* 🔥 DESKTOP HEADER */}
      <header className="hidden md:block w-full bg-gradient-to-r from-[#0f172a] to-[#1e293b] text-white shadow fixed top-0 z-50">

        <div className="max-w-7xl mx-auto px-2 py-3 flex items-center justify-between">

          {/* LOGO */}
          <Link to="/">
            <motion.img
              whileHover={{ scale: 1.1 }}
              src={logo}
              alt="logo"
              className="h-14"
            />
          </Link>

          {/* SEARCH */}
          <form
            onSubmit={handleSearch}
            className="flex items-center bg-white/10 backdrop-blur-md border border-white/20 rounded-full overflow-hidden w-[520px]"
          >
            <input
              type="text"
              placeholder={placeholder}
              className="flex-1 px-4 py-2 outline-none text-sm bg-transparent text-white placeholder-gray-300"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <button className="bg-red-500 px-5 py-2">
              <GrSearch />
            </button>
          </form>

          {/* RIGHT */}
          <div className="flex items-center gap-6">

            {/* USER */}
            {user ? (
              <div className="relative">

                <div
                  onClick={() => setDropdown(!dropdown)}
                  className="cursor-pointer text-center"
                >
                  <div className="w-9 h-9 rounded-full bg-white text-black flex items-center justify-center">
                    {user.name?.charAt(0)}
                  </div>
                  <span className="text-xs">{user.name?.split(" ")[0]}</span>
                </div>

                {dropdown && (
                  <div className="absolute right-0 mt-2 w-44 bg-white text-black rounded-xl shadow-lg p-2">

                    <Link to="/account/profile" onClick={()=>setDropdown(false)} className="block px-3 py-2 hover:bg-gray-100 rounded">
                      My Account
                    </Link>

                    <Link to="/account/orders" onClick={()=>setDropdown(false)} className="block px-3 py-2 hover:bg-gray-100 rounded">
                      Orders
                    </Link>

                    <button onClick={handleLogout} className="w-full text-left px-3 py-2 text-red-500 hover:bg-gray-100 rounded">
                      Logout
                    </button>

                  </div>
                )}
              </div>
            ) : (
              <Link to="/login">
                <FaUser />
              </Link>
            )}

            {/* CART */}
            <Link to="/cart" className="relative">
              <FaShoppingCart />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs px-1 rounded-full">
                  {cartCount}
                </span>
              )}
            </Link>

          </div>
        </div>
      </header>

      {/* 🔥 MOBILE HEADER */}
      <div className="md:hidden fixed top-0 w-full bg-gradient-to-r from-[#0f172a] to-[#1e293b] text-white z-50 shadow">

        <div className="flex items-center justify-between px-2 py-2 gap-2">

          {/* LEFT */}
          <div className="flex items-center gap-2">

            {/* HAMBURGER */}
            <div
              onClick={() => setMenuOpen(true)}
              className="w-9 h-9 flex flex-col justify-center items-center gap-[3px] rounded-lg bg-white/10 backdrop-blur cursor-pointer"
            >
              <span className="w-5 h-[2px] bg-white rounded"></span>
              <span className="w-5 h-[2px] bg-white rounded"></span>
              <span className="w-5 h-[2px] bg-white rounded"></span>
            </div>

            <Link to="/">
              <img src={logo} alt="logo" className="h-8" />
            </Link>
          </div>

          {/* SEARCH */}
          <form onSubmit={handleSearch} className="flex-1 max-w-[140px]">
            <div className="flex items-center bg-white/10 backdrop-blur-md border border-white/20 rounded-full overflow-hidden">
              <input
                type="text"
                placeholder="Search..."
                className="w-full px-2 py-1 text-xs bg-transparent outline-none text-white placeholder-gray-300"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <button className="px-2 text-sm">
                <GrSearch />
              </button>
            </div>
          </form>

          {/* RIGHT */}
          <div className="flex items-center gap-3">

            <Link to={user ? "/account/profile" : "/login"}>
              <FaUser size={16} />
            </Link>

            <Link to="/cart" className="relative">
              <FaShoppingCart size={16} />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] px-1 rounded-full">
                  {cartCount}
                </span>
              )}
            </Link>

          </div>
        </div>
      </div>

      {/* 🔥 MOBILE DRAWER */}
      <div className={`fixed top-0 left-0 h-full w-[75%] sm:w-[60%] bg-white z-50 shadow-2xl transform transition-transform duration-300 ${menuOpen ? "translate-x-0" : "-translate-x-full"}`}>

        {/* HEADER */}
        <div className="p-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white flex justify-between items-center">
          <span className="font-semibold text-lg">Menu</span>
          <button onClick={() => setMenuOpen(false)} className="text-xl">✕</button>
        </div>

        {/* LINKS */}
        <div className="px-4 py-6 flex flex-col gap-4 text-base">

          <Link to="/" onClick={()=>setMenuOpen(false)} className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100">
            <FaHome /> Home
          </Link>

          {user ? (
            <>
              <Link to="/account/profile" onClick={()=>setMenuOpen(false)} className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100">
                <FaUser /> My Account
              </Link>

              <Link to="/account/orders" onClick={()=>setMenuOpen(false)} className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100">
                <FaBox /> Orders
              </Link>

              <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2 rounded-lg text-red-500 hover:bg-red-50 text-left">
                <FaSignOutAlt /> Logout
              </button>
            </>
          ) : (
            <Link to="/login" onClick={()=>setMenuOpen(false)} className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100">
              <FaUser /> Login
            </Link>
          )}

        </div>
      </div>

      {/* OVERLAY */}
      {menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          className="fixed inset-0 bg-black/40 z-40"
        />
      )}

    </>
  );
};

export default Header;